import { SectionLayout } from "@/components/layout/section-layout";
import { PlanBadge } from "@/components/features/plan-badge";
import { useWeeklyChangeCount } from "@/lib/hooks/use-header-monitoring";
import { useSiteScope } from "@/lib/hooks/use-site-scope";
import { formatNumber } from "@/lib/utils/format-number";

/**
 * Headers' tab row (ADR 013), with the Changes tab's count of the last week's
 * changes (task 374) so a change is visible from the Pages tab too. The count
 * is the scoped site's, or every site's under "all sites"; nothing is drawn
 * until it is known, and nothing when it is zero.
 *
 * The Pages tab wears its plan badge (task 450): marking payment pages, and
 * the daily scans, are on the Professional plan and above.
 */
export function HeadersLayout() {
  const { siteId, sites } = useSiteScope();
  const count = useWeeklyChangeCount(
    siteId ? [siteId] : sites.map((site) => site.id),
  );

  return (
    <SectionLayout
      section="headers"
      tabBadges={{
        "/dashboard/headers": (
          <PlanBadge capability="pages.payment" className="ml-2" />
        ),
        ...(count
          ? {
              "/dashboard/headers/changes": (
                <span
                  className="ml-2 rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-foreground"
                  data-testid="header-changes-badge"
                >
                  {formatNumber(count)} this week
                </span>
              ),
            }
          : {}),
      }}
    />
  );
}
